import { Injectable } from '@angular/core';
import { INameId } from '@modeso/types__aumico-lib-core-be';

@Injectable({ providedIn: 'root' })
export class SelectComponentHelper {
    getSelectedOptionOfSelectionOptions(selectionOptions: INameId[], selectedOption: string): INameId {
        const noSelectedOption: boolean = selectedOption == null || selectedOption == '';

        if (noSelectedOption) {
            return null;
        }

        return selectionOptions.find((option) => option.id === selectedOption);
    }
}
